import Image from "next/image";
import { useAppContext } from "../../../../_context";

const SportSelectionItem = ({ item, checked = false }) => {
  const [{ tx }] = useAppContext();
  const opts = {};

  if (checked) {
    opts.defaultChecked = true;
  }

  return (
    <label className="sport-item" htmlFor={`sport-${item}`}>
      <input
        id={`sport-${item}`}
        type="radio"
        className="d-none sport-selection-item"
        name="sport-selection"
        {...opts}
        value={item}
      />

      <span className="icon">
        <Image
          src={`/img/icons/${item}_black.svg`}
          width={37}
          height={37}
          unoptimized={true}
        />
      </span>

      <span className="label">{tx[item]}</span>
    </label>
  );
};

export default SportSelectionItem;
